const styles = {
  textInput: {
    backgroundColor: "white",
    fontSize: "12px",
    fontWeight: "400",
    fontFamily: "inter",
    paddingLeft: "4px",
    height: "30px",
  },
  menu: {
    width: "100%",
    "& .MuiPaper-root": {
      borderRadius: "10px",
    },
  },
  menuContainer: {
    paddingInline: "10px",
  },
  menuHeader: {
    color: "var(--Grey, #C4C4C4)",
    fontFamily: "Inter",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    display: "flex",
    justifyContent: "space-between",
  },
  closeIcon: {
    fontSize: "16px",
    cursor: "pointer",
    "&:hover": { color: "black" },
  },
  menuBody: {
    display: "flex",
  },
  ul: {
    listStyleType: "none",
    marginBlock: 0,
    padding: 0,
    paddingLeft: "4px",
    overflow: "auto",
  },
  selectAllBox: {
    display: "flex",
    justifyContent: "flex-start",
  },
  selectAllLabel: {
    color: "#c4c4c4",
    fontFamily: "Inter",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    display: "flex",
    justifyContent: "space-between",
  },
  optionsBox: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: "5px",
  },
  optionsColumn: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    marginRight: "0px",
    marginLeft: "5px",
  },
  li: {
    borderLeft: "1px solid #CADEDD",
    paddingLeft: "10px",
    paddingBlock: "5px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  liDiv: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  liBox: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
  },
  liSpan: {
    flex: "0 0 50%",
    textAlign: "right",
    marginRight: "16px",
  },
  checkboxLabel: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  adsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  adsBox: {
    flex: 1,
    display: "flex",
  },
  adsLabel: {
    color: "gray",
    fontFamily: "Inter",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    display: "flex",
    justifyContent: "space-between",
  },
  adsColumn: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "5px",
  },
  adsSpan: {
    flex: "0 0 50%",
    textAlign: "right",
  },
  checkboxSx: {
    color: "#000",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
  footerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "14px",
    paddingBlock: "8px",
  },
  unselectAllSpan: {
    flex: "0 0 50%",
    marginRight: "16px",
    fontSize: "10px",
    cursor: "pointer",
  },
  applyButton: {
    color: "black",
    backgroundColor: "#61D5A9",
    borderRadius: "20px",
    fontSize: "10px",
    width: "100px",
    paddingInline: "8px",
    fontFamily: "inter",
    height: "20px",
  },
};

export default styles;